import { IsNotEmpty } from "class-validator";
import { IAdapterFolderJobValidationSummaryAction } from "./adapter-folder-job-validation-summary-action.interface";

export class AdapterFolderJobValidationSummaryActionDto
  implements IAdapterFolderJobValidationSummaryAction
{
  @IsNotEmpty()
  folder_id: string;
}
